import { useEffect, useState } from "react";
import MySegmented from "../../components/segmented/Segmented";
import Earning from "../../assets/dashboard/Earning";
import Deposit from "../../assets/wallet/Deposit";
import Withdraw from "../../assets/wallet/Withdraw";
import AreaChart from "../../components/global/charts/AreaChart";
import { Cookies } from "react-cookie";
import useWebSocket from "react-use-websocket";
import UserAvatar from "../../components/global/avtar/UserAvatar";
import { GetTraderAccountsByIdApi } from "../../api/request/client";
import { useParams } from "react-router-dom";
import moment from "moment";
import IbCommission from "../../assets/ibCommision/IbCommission";
import Commission from "../../assets/Commission";
import OpenPL from "../../assets/wallet/OpenPL";
import { iconButton } from "@material-tailwind/react";
import ClosePL from "../../assets/ClosePL";
import RMS from "../../assets/RMS";
import OpenTrades from "../../assets/OpenTrades";
import CloseTrades from "../../assets/CloseTrades";
import TotalTrades from "../../assets/TotalTrades";
import InOut from "../../assets/InOut";

const AnalyticsView = () => {
    const { loginId } = useParams();
    const [account, setAccount] = useState(loginId);
    const primaryColor = (getComputedStyle(document.documentElement).getPropertyValue('--theme'))?.trim();

    const cookies = new Cookies();
    const [socketData, setSocketData] = useState(null);

    const data = { name: "Daniel Walker", email: "daniel_walker@yopmail.com" };

    const transactionCards = [
        { title: 'Open P/L', value: socketData?.OpenTradeProfit.toFixed(2) || 0, bgColor: "bg-[#E6F1F3]", icon: <OpenPL color="#2dc7e3" size={7} /> },
        { title: 'Closed P/L', value: socketData?.CloseTradeProfit.toFixed(2) || 0, bgColor: "bg-[#E9E7FD]", icon: <ClosePL color="#6158bb" size={7} /> },
        { title: 'Current Equity', value: socketData?.CurrentEquity.toFixed(2) || 0, bgColor: "bg-[#DDF6E8]", icon: <Earning color="#28C76F" size={7} /> },
        { title: 'Deposit', value: socketData?.Deposit.toFixed(2) || 0, bgColor: "bg-[#D6F4F8]", icon: <Deposit color="#00BAD1" size={7} /> },
        { title: 'Withdraw', value: socketData?.Withdraw.toFixed(2) || 0, bgColor: "bg-[#FFF0E1]", icon: <Withdraw color="#FF9F43" size={7} /> },
    ];

    const earningCards = [
        { title: 'In | Out', value: socketData?.InOut.toFixed(2) || 0, prefix: "$", bgColor: "bg-[#E6F1F3]", icon:<InOut color="#2dc7e3" size={7} /> },
        { title: 'RMS', value: socketData?.RMSAmount.toFixed(2) || 0, prefix: "$", bgColor: "bg-[#E9E7FD]", icon:<RMS color="#6158bb" size={7} /> },
        { title: 'Total Lots', value: socketData?.TotalLots || 0, bgColor: "bg-[#DDF6E8]", icon:<Commission color="#28C76F" size={7} /> },
        { title: 'Open Trades', value: socketData?.OpenTrades || 0, bgColor: "bg-[#D6F4F8]", icon:<OpenTrades color="#00BAD1" size={7} /> },
        { title: 'Closed Trades', value: socketData?.CloseTrades || 0, bgColor: "bg-[#FFF0E1]", icon:<CloseTrades color="#FF9F43" size={7} /> },
        { title: 'Total Trades', value: socketData?.TotalTrades || 0, bgColor: "bg-[#FFE2E3]", icon:<TotalTrades color="#FF4C51" size={7} /> },
    ];

    const chartData = { categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"], series: [{ name: "Profit", data: [50, 100, 80, 150, 120, 200] }] };

    const getTradingAccount = async () => {
        try {
            const { data } = await GetTraderAccountsByIdApi(1, true);
            if (data?.success) {
                setAccount(data?.data);
            }
        } catch (error) { }
    }

    const { sendJsonMessage, lastJsonMessage } = useWebSocket(
        `wss://backend.rimglobal.trade/api/MTFiveAccount/ws?authorization=Bearer ${cookies.get("token")}`,
        { shouldReconnect: () => true, share: true }
    );

    useEffect(() => {
        sendJsonMessage({ "eventType": "TradeAccountOverview", "action": "subscribe", "loginId": loginId });
        return () => {
            sendJsonMessage({ eventType: "TradeAccountOverview", action: "unsubscribe", "loginId": loginId });
        };
    }, []);

    useEffect(() => { setSocketData(lastJsonMessage?.data?.Data?.[0]); }, [lastJsonMessage]);


    return (
        <div>
            {/* <div className="flex items-center justify-between gap-5 mb-5">
                <MySegmented options={["1001", "1002"]} value={account} setValue={setAccount} />
            </div> */}

            {/* <div className="grid sm:grid-cols-2 gap-5 border-2 border-light rounded-[10px] p-5 mb-5">
                <div className="flex items-center gap-3">
                    <div>
                        <UserAvatar data={{ name: data?.name, email: data?.email, profileImage: data?.profileImage }} />
                    </div>
                </div>

                <div className="flex justify-end gap-2">
                    <div className="flex gap-2">
                        <p className="font-medium">Joined Date:</p>
                        <p className="primary font-semibold">{moment().format("DD-MM-YYYY")}</p>
                    </div>
                    <div className="flex gap-2">
                        <p className="font-medium">Last Login:</p>
                        <p className="primary font-semibold">{moment().format("DD-MM-YYYY HH:mm:ss A")}</p>
                    </div>
                    <div className="w-fit">
                        <MySegmented options={["1001", "1002"]} value={account} setValue={setAccount} />
                    </div>
                </div>
            </div> */}

            <div className="grid md:grid-cols-2 xl:grid-cols-5 gap-5 mb-5">
                {transactionCards?.map((card, index) => (
                    <div className="flex items-center justify-between border-2 border-light rounded-[10px] p-5" key={index}>
                        <div>
                            <p className="text-2xl font-semibold text-gray-800 mb-1">${card?.value || 0}</p>
                            <p className="text-gray-500">{card?.title}</p>
                        </div>
                        <div className={`flex justify-center items-center  w-12 h-12 rounded-lg ${card?.bgColor || 'bg-primary-light'}`}>
                            {card?.icon}
                        </div>
                    </div>
                ))}
            </div>

            <div className="grid md:grid-cols-2 gap-5">
                <div className="grid lg:grid-cols-3 sm:grid-cols-2 gap-5 ">
                    {earningCards?.map((card, index) => (
                        <div className="flex flex-col items-center justify-center gap-3 border-2 border-light rounded-[10px] p-5 " key={index}>
                            <div className={`flex justify-center items-center w-12 h-12 rounded-lg mb-2 ${card?.bgColor || 'bg-primary-light'} `}>
                                {card?.icon}
                            </div>
                            <div className="text-center">
                                <p className="text-3xl font-semibold text-gray-800 mb-1">{card?.prefix}{card?.value || 0}</p>
                                <p className="text-xl text-gray-500">{card?.title}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="border-2 border-light rounded-[10px] p-5">
                    <h2 className="text-title font-semibold">Profit</h2>
                    <AreaChart data={chartData} colors={[primaryColor]} />
                </div>
            </div>
        </div>
    )
}

export default AnalyticsView